// Copyright (c) Docugami, Inc. All rights reserved.

export interface ApiKey {
    id: string;
    url: string;
    scopes: string[];
    createdAt: string;
    name: string;
    key?: string;
}

export interface ApiKeysResponse {
    keys: ApiKey[];
}

export interface ApiKeyRequest {
    scopes: string[];
    name: string;
}

export const DEFAULT_SCOPES: string[] = ['read:documents', 'write:documents', 'read:projects', 'write:projects', 'read:workspace', 'write:workspace'];
